export const ONE_THIRD_PROGRESS = '@@header/ONE_THIRD_PROGRESS';
export const TWO_THIRDS_PROGRESS = '@@header/TWO_THIRDS_PROGRESS';
export const THREE_THIRDS_PROGRESS = '@@header/THREE_THIRDS_PROGRESS';
